export default "__VITE_ASSET__B9jP3NC5__"